define(function(require) {

	// templates
	const tpl = require('./t_itv_ss_item.hbs');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.readOnlyIcons = options.readOnlyIcons === true ? true : false;
		},
		template: tpl,
		events: {
			'click @ui.favoriteIcon':'favoriteClicked',
			'click @ui.removeIcon':'removeClicked'
		},
        ui: {
			favoriteIcon:'.favorite-icon',
			removeIcon:'.remove-icon'
        },
        onRender:function(){

   		},
		favoriteClicked:function(e){
			e.stopPropagation();
			e.preventDefault();
			this.model.collection.trigger('setPrimarySite',this.model);
		},
		removeClicked:function(e){
			e.stopPropagation();
			e.preventDefault();
			this.model.collection.remove(this.model);
		},
		templateHelpers: function() {
			return {
				classes:this.model.get('primarySite') === true ? ' primary-selected-site' : '',
				isPrimary:this.model.get('primarySite') === true,
				hideFavoriteIconCSS:this.model.get('_canBePrimarySite') === false || 
					this.model.get('primarySite') === true  || 
					this.readOnlyIcons ? ' hidden' : '',
				hideRemoveIconCSS:this.readOnlyIcons ? ' hidden' : '',

			}
		}
	});
});
